export const trimestres = [
    { id: "1", trimestre: "1° trimestre" }, { id: "2", trimestre: "2° trimestre" }, { id: "3", trimestre: "3° trimestre" }
]

export const anos = [
    { id: "1", ano: "1° ano" }, { id: "2", ano: "2° ano" }, { id: "3", ano: "3° ano" }
]

export const notacoesPadrao = [
    {valor: 0, nome: ''},
    {valor: 1, nome: 'AB'},
    {valor: 2, nome: 'B'},
    {valor: 3, nome: 'AD'},
    {valor: 4, nome: 'AV'}
]

